import React from "react";

import { Container, Dot, Pill } from "./styles";

const FLAG_BY_LANG: Record<string, string> = {
    ru: "🇷🇺",
    en: "🇺🇸",
    it: "🇮🇹",
    zh: "🇨🇳",
};

interface LanguageSegmentedControlProps {
    languages: string[];
    activeLang: string;
    primaryLang: string;
    onChange: (lang: string) => void;
    // Точка-индикатор у неосновных языков: перевод для языка пустой.
    isMissing: (lang: string) => boolean;
}

export const LanguageSegmentedControl = ({
    languages,
    activeLang,
    primaryLang,
    onChange,
    isMissing,
}: LanguageSegmentedControlProps) => (
    <Container>
        {languages.map((lang) => (
            <Pill
                key={lang}
                type="button"
                $active={lang === activeLang}
                onClick={() => onChange(lang)}
            >
                <span>{FLAG_BY_LANG[lang]}</span>
                <span>{lang.toUpperCase()}</span>
                {lang !== primaryLang && <Dot $visible={isMissing(lang)} />}
            </Pill>
        ))}
    </Container>
);
